import { api } from "assets/scripts/utilities/api-clients";

export const index = async (
  options = {
    params: {
      showMessage: false,
    },
  },
) => {
  const response = await api.get("/kam/pdf-templates", options);

  return response;
};
